/** @jsxImportSource @emotion/react */
import React, { useState, useEffect, useRef } from 'react'
import Box from '@mui/material/Box'
import MobileStepper from '@mui/material/MobileStepper'
import Button from '@mui/material/Button'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'

const AUTO_STEP_MS = 20000

export const Carousel = ({children, autoStep=false}) => {
  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = children.length
  const _timer = useRef(null)

  const handleNext = () => {
    resetTimer()
    setActiveStep(prev => prev >= (maxSteps-1) ? 0 : prev+1)
  }
  const handleBack = () => {
    resetTimer()
    setActiveStep(prev => prev <= 0 ? maxSteps-1 : prev-1)
  }
  const resetTimer = () => {
    if (autoStep){
      clearInterval(_timer.current)
      _timer.current = setInterval(handleNext, AUTO_STEP_MS)
    }
  }

  useEffect(() => {
    resetTimer()
    return () => clearInterval(_timer.current)
  }, [autoStep])

  return (
    <Box className='carousel'>
      <Box>
        {children[activeStep]}
      </Box>
      <MobileStepper
        style={{background: 'none'}}
        css={styles.stepper}
        variant="dots"
        steps={maxSteps}
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext}>
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack}>
            <KeyboardArrowLeft />
          </Button>
        }
      />
    </Box>
  )
}


const styles = {
  stepper: {
    padding: 0,
    '& button': {
      color: '#fff'
    },
    '& .MuiMobileStepper-dot': {
      backgroundColor: '#6b6b6b'
    },
    '& .MuiMobileStepper-dotActive': {
      backgroundColor: '#D5D5D5'
    },
  }

}

export default Carousel